import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { BOTS, EXPERTS } from '@guuru/expert-common';
import { Col, Space } from 'antd';
import { MarkdownRender } from '@guuru/react-markdown-render';
import { ExpertAvatar } from '@guuru/react-chat-avatar';
import Wrapper from './styles';
import SubTitle from './SubTitle';
import useBottomSheet from '../../../hooks/useBottomSheet';

const getFormatedHeadline = (headline) => (
  headline.startsWith('#') ? headline : `# ${headline}`
);

const Headline = function ({ chat = {} }) {
  const { t } = useTranslation();
  const { openBottomSheet } = useBottomSheet();
  const { expert, isAssignedToAgent: isAgent } = chat;
  const expertName = expert?.name;
  const expertAvatar = expert?.photoUrl ?? EXPERTS.default.photoUrl;
  const isBot = expert?.id === BOTS.bot.externalId;
  const isCopilot = expert?.id === BOTS.copilot.externalId;
  const isGuuru = !isAgent && !isCopilot && !isBot && expertName;

  const subtitle = () => {
    if (isAgent) return t('chat:::headlineAgent');
    if (isCopilot) return t('chat:::headlineGptBot');
    if (isGuuru) return t('chat:::headlineGuuru');
    return null;
  };

  const title = (!expertName || isBot)
    ? t('chat:::headline')
    : expertName;

  return (
    <Wrapper wrap={false} onClick={isGuuru ? openBottomSheet : null}>
      <Space size={6}>
        {(!isBot && (expertAvatar !== EXPERTS.default.photoUrl)) && (
          <Col flex="none" aria-hidden="true">
            <ExpertAvatar url={expertAvatar} size={48} />
          </Col>
        )}
        <Col flex="auto">
          <MarkdownRender content={getFormatedHeadline(title)} />
          <SubTitle text={subtitle()} />
        </Col>
      </Space>
    </Wrapper>
  );
};

Headline.propTypes = {
  chat: PropTypes.shape({
    id: PropTypes.string,
    expert: PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      photoUrl: PropTypes.string,
    }),
    isAssignedToAgent: PropTypes.bool,
  }),
};

export default Headline;
